import { useEffect } from "react";
import { ERROR_401 } from "config/errorPage";
import { verifyPermission } from "helpers/permission";

export const PermissionGuard = ({ userPermissions, children, ready }) => {
  useEffect(() => {
    if (
      ready &&
      !verifyPermission(
        userPermissions,
        "update-reject-unit-transfer-parameters"
      )
    ) {
      window.location.href = ERROR_401;
    }
  }, [userPermissions, ready]);

  if (!ready) return null;

  if (
    !verifyPermission(userPermissions, "update-reject-unit-transfer-parameters")
  ) {
    return null;
  }

  return children;
};
